import { useActiveMember } from 'hooks/store';

// Redux active member is sent to an empty object when the user is logged out.
export default function useIsLoggedIn() {
  const activeMember = useActiveMember();
  return activeMember && !!activeMember.id;
}
